export { default as Google } from "./Google"
export { default as Facebook } from "./Facebook"
export { default as Close } from "./Close"
export { default as DfAvatar } from "./DfAvatar"
export { default as icLogo } from "./logo"
export { default as QrcodeVina } from "./QrcodeVina"
export { default as DefaultImage } from "./DefaultImage"
export { default as IconDftransaction } from "./IconDftransaction"
export { default as DfAvatarLogin } from "./DefaultAvatar"
export { default as Image3x1 } from "./3x1"
export { default as Image4x6 } from "./4x6"
export { default as Image16x9 } from "./16x9"
export { default as QrcodeOnlus } from "./QrcodeOnlus"
export { default as TagBasic } from "./TagBasic"
export { default as TagPremium } from "./TagPremium"
export { default as TagPremiumPlus } from "./TagPremiumPlus"
export { default as IconArrowDown } from "./IconArrowDown"
export { default as IconArrowUp } from "./IconArrowUp"
export { default as IconNoChat } from "./IconNoChat"
export { default as IconSend } from "./IconSend"
